module.exports = __webpack_public_path__ + "07ddc04901454fd03b03d4f48ce16182.svg";